module.exports = __webpack_public_path__ + "img/nav_icon.2f9a302.png";